export var DeviceType;
(function (DeviceType) {
    DeviceType["Mobile"] = "Mobile";
    DeviceType["Tablet"] = "Tablet";
    DeviceType["TabletWeb"] = "TabletWeb";
    DeviceType["TabletNative"] = "TabletNative";
    DeviceType["Desktop"] = "Desktop";
    DeviceType["MobileNative"] = "MobileNative";
    DeviceType["MobileWeb"] = "MobileWeb";
    DeviceType["MobileNativeAndroid"] = "MobileNativeAndroid";
    DeviceType["MobileWebAndroid"] = "MobileWebAndroid";
    DeviceType["MobileNativeIos"] = "MobileNativeIos";
    DeviceType["MobileWebIos"] = "MobileWebIos";
})(DeviceType || (DeviceType = {}));
export const getDeviceType = () => {
    const whDeviceCookieValue = (document.cookie.split('; ').find((row) => row.startsWith('wh_device=')) || '').split('=')[1];
    if (!whDeviceCookieValue)
        return null;
    const parsedCookie = JSON.parse(whDeviceCookieValue);
    if (parsedCookie.device_os === 'desktop') {
        return DeviceType.Desktop;
    }
    if (String(parsedCookie.is_tablet) === 'true') {
        if (String(parsedCookie.is_native) === 'true') {
            return DeviceType.TabletNative;
        }
        return DeviceType.TabletWeb;
    }
    if (String(parsedCookie.is_native) === 'true') {
        if (String(parsedCookie.device_os) === 'android') {
            return DeviceType.MobileNativeAndroid;
        }
        return DeviceType.MobileNativeIos;
    }
    return DeviceType.MobileWeb;
};
//# sourceMappingURL=getDeviceType.js.map